import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '' });

const TOKEN_KEY = 'auth_token';

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  delete api.defaults.headers.common['Authorization'];
};

export const loadStoredToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return token;
  }
  return null;
};

// AUTH
export const login           = (data) => api.post('/api/auth/login', data);
export const logout          = ()     => api.post('/api/auth/logout');
export const getMe           = ()     => api.get('/api/auth/me');
export const setPassword     = (data) => api.post('/api/auth/set-password', data);

// SERVER MANAGEMENT
export const getServerList   = (viewType, search) => api.get('/api/servermanagement/list', { params: { viewType, search } });
export const getMasterData   = ()     => api.get('/api/servermanagement/master-data');
export const getServerInfo   = (params) => api.get('/api/servermanagement/server-info', { params });
export const saveServerInfo  = (data) => api.post('/api/servermanagement/save-server-info', data);
export const blockServer     = (data) => api.post('/api/servermanagement/block', data);
export const unblockServer   = (data) => api.post('/api/servermanagement/unblock', data);
export const removeServer    = (data) => api.post('/api/servermanagement/remove', data);
export const saveIntimation  = (data) => api.post('/api/servermanagement/save-intimation', data);
export const getFirewall     = (params) => api.get('/api/servermanagement/firewall', { params });
export const saveFirewall    = (data) => api.post('/api/servermanagement/save-firewall', data);

// CLOUD SERVER IPs
export const getCloudIPs     = ()     => api.get('/api/cloudserverip/list');

// UPDATE SERVER DETAILS
export const getUpdateList   = ()     => api.get('/api/updateserverdetails/list');
export const updateRack      = (data) => api.post('/api/updateserverdetails/update-rack', data);
